import { useRouteError } from "react-router-dom";
import React from 'react'; // 'React' must be in scope when using JSX

interface RouteError {
  statusText?: string;
  message: string;
}

export default function ErrorPage(): JSX.Element {
  const error = useRouteError() as RouteError;
  console.error(error);

  return (
    <div id="error-page" className="min-h-screen flex items-center justify-center bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 p-10 bg-gray-800 rounded-xl shadow-lg text-center">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-white">
            Something Went Wrong!
          </h2>
          <p className="mt-2 text-center text-md text-gray-400">
            We've encountered an error trying to process your request.
          </p>
          <p className="mt-2 text-center text-md text-red-400 italic">
            {error.statusText || error.message || "Unknown error"}
          </p>
        </div>
      </div>
    </div>
  );
}
